<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded img-fluid t_imgCircle"
                  />
                </div>
                <div class="name">
                  <h1 class="title">Contact Us</h1>
                  <h4>We are here to help!</h4>
                  <md-button
                    href="https://www.facebook.com/daysinnsherman"
                    class="md-just-icon md-simple md-dribbble"
                    ><i class="fab fa-facebook-square"></i>
                  </md-button>
                  <md-button
                    href="https://twitter.com/DaysSherman"
                    class="md-just-icon md-simple md-twitter"
                    ><i class="fab fa-twitter-square"></i></md-button>
                  <md-button
                    href="https://www.instagram.com/daysinnsherman/"
                    class="md-just-icon md-simple md-pinterest"
                    ><i class="fab fa-instagram"></i></md-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section t_contact">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-20 md-small-size-100 mx-auto">
            </div>
            <div class="md-layout-item md-size-29 md-small-size-100 mx-auto">
              <h3 class="title">Our Address</h3>
              <h4>3605 US-75, <br>
                  Sherman, TX 75090</h4>
              <h3 class="title">Our Phone</h3>
              <h4>(903) 868-0555</h4>
              <h3 class="title">Our Message</h3>
              <h4>(903) 718-0189</h4>
            </div>
            <hr>
            <div class="md-layout-item md-size-10 md-small-size-100 mx-auto">
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100 mx-auto">
              <form novalidate @submit.prevent="validateUser">
                <md-field :class="getValidationClass('firstName')">
                  <md-icon>person</md-icon>
                  <md-input :disabled="sending" name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" placeholder="    User Name"/>
                  <div class="md-error" v-if="!$v.form.firstName.required">The user name is required</div>
                  <div class="md-error" v-else-if="!$v.form.firstName.minlength">Invalid user name</div>
                </md-field>
                <md-field :class="getValidationClass('email')">
                  <md-icon>email</md-icon>
                  <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending"  placeholder="    Email"/>
                  <div class="md-error" v-if="!$v.form.email.required">The email is required</div>
                  <div class="md-error" v-else-if="!$v.form.email.minlength">Invalid email</div>
                </md-field>
                <md-field :class="getValidationClass('message')">
                  <md-icon>message</md-icon>
                  <md-input type="message" name="message" id="message" autocomplete="message" v-model="form.message" :disabled="sending"  placeholder="    Message" />
                  <div class="md-error" v-if="!$v.form.message.required">The Message is required</div>
                  <div class="md-error" v-else-if="!$v.form.message.minlength">Invalid Message</div>
                </md-field>
                <vue-recaptcha @verify="onVerify" @expired="onExpired" size="normal" sitekey="6Lei6CQfAAAAANc7C_nC3ZubcCIq8Zv4lBdhkwAr">
                </vue-recaptcha>
                <md-button
                type="submit" 
                  ref="t_submitMsg"
                  class="md-orange md-lg t_btn" :disabled="sendBtn"
                  ><md-icon>send</md-icon> Send
                </md-button>
              </form>
            </div>
            <div class="md-layout-item md-size-15 md-small-size-100 mx-auto">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-map"> 
      <div class="">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.3376123703806!2d-96.60600908436703!3d33.59654364905292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c62ec92834455%3A0x87c507aebc3493e3!2sDays+Inn+by+Wyndham+Sherman!5e0!3m2!1sen!2sus!4v1560976575457!5m2!1sen!2sus" width="1920" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Tabs } from '@/components'
// import VueRecaptcha from 'vue-recaptcha'
import { VueRecaptcha } from 'vue-recaptcha'
import { validationMixin } from 'vuelidate'
import {required,email,minLength,maxLength} from 'vuelidate/lib/validators'
export default {
  components: {
    Tabs,
    VueRecaptcha,
    validationMixin,
    required,email,minLength,maxLength
  },
  bodyClass: "profile-page",
  data() {
    return {
      form: {
        firstName: null,
        email: null,
        message: null
      },
      sending: false,
      sendBtn: true
    };
  },
  mixins: [validationMixin],
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50)
      },
      email: {
        required,
        email
      },
      message: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(255)
      }
      // address:  {
      //   required
      // },
      // city: {
      //   required,
      //   alphaNum
      // },
      // postalcode: {
      //   required,
      //   numeric,
      //   minLength: minLength(5),
      //   maxLength: maxLength(5)
      // },
      // state: {
      //   required,
      //   alpha
      // }
    }
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/contact_header.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/menulogo.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid md-error': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.firstName = ''
      this.form.message = ''
      this.form.email = ''
    },
    saveUser () {
      this.sending = true
      // Instead of this timeout, here you can call your API
      console.log(1)
      window.setTimeout(() => {
        // this.lastUser = `${this.form.firstName} ${this.form.lastName}`
        // this.userSaved = true
        this.sending = false
        this.sendBtn = false
        this.sendToEmail()
        
      }, 1500)
    },
    validateUser () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saveUser()
      }else{
        // this.submitStatus = 'ERROR'
      }
    },
    sendToEmail: function () {
      console.log('sendtoemail', this.form.firstName, this.form.email, this.form.message)
      let that = this
      let data = JSON.stringify({"username":this.form.firstName,"email":this.form.email,"message":this.form.message});
      axios.post('/cgi-bin/php/sendToEmail.php', data).then((res) => {
        alert("success!")
      }).catch((error) => {
        console.log(error)
      }).finally((res) => {
        that.clearForm()
      })
    },
    onSubmit: function () {
      console.log('onSubmit')
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function (response) {
      console.log('Verify: ', this.$refs)
      this.sendBtn = false
      // this.$refs.t_submitMsg.disabled = false
    },
    onExpired: function () {
      this.sendBtn = true
      // this.$refs.t_submitMsg.disabled = true
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  },
  mounted() {
    // load('6Lew0ckUAAAAAOzpt0RGnYK5HNQ7yW2cRDfu0hYV').then((recaptcha) => {
    //   recaptcha.execute('<action>').then((token) => {
    //       console.log(token) // Will print the token
    //     })
    // })
    // grecaptcha.ready(function() {
    //   var renderKey = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'
    //   grecaptcha.execute(renderKey, {action: '/'}).then(function(token) {
    //       $('input[name="token"]').val(token)
    //       $('.submit-btn').removeAttr('disabled')
    //   })
    // }) 
  }
};
</script>

<style lang="scss" scoped>

.section {
  padding: 0;
}
.t_imgCircle {
  background: rgba(0, 0, 0, 0.5);
  border: 3px solid rgb(245, 124, 0);
  padding: 5px;
}
.t_contact {
  padding-bottom: 40px;
  .t_btn {
    width: 100%;
    margin: 20px 0;
  }
  .t_msg {
    width: 100%;
    margin-top: 0px!important;
    min-height: 60px;
    padding-left: 0px !important;
  }
}
.profile-tabs /deep/ {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
.section.section-map {
  padding-top: 0;
  padding-bottom: 0;
  iframe {
    height: 50vW !important;
  }
}
.md-field {
  .md-error{
    bottom: -8px;
    left: 50px;
  }
}
#message{
  margin-bottom: 30px;
}
</style>
